module.exports = __webpack_public_path__ + "img/conjunctival-hyperemia-0.7c409e7e.jpg";